import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'

export function loginGuard(to, from, next) {
  const authStore = useAuthStore()
  const loggedIn = authStore.isLoggedIn

  if (loggedIn) {
    const clubId = getActiveClubId()

    if (!clubId) {
      console.log('[loginGuard] No clubId found')
      next('/auth/club-selector')
      return
    }

    console.log('[loginGuard] User is already logged in, redirecting to /logged (but not for now)')
    // if we enable below line, it gives infinite redirect loop
    // next('/landing')
  }

  next()
}
